<template>
  <el-menu router
           :default-active="$route.path"
           class="el-menu-vertical-demo">
    <el-submenu index="1">
      <template slot="title">
        <i class="el-icon-fa-cog"></i>
        <span>基础设置</span>
      </template>
      <el-menu-item index="/system">默认参数配置</el-menu-item>
      <el-menu-item index="/system/sync">同步器配置</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'system-nav',
};
</script>



// WEBPACK FOOTER //
// src/components/SystemNav.vue